module.exports = __webpack_public_path__ + "static/img/rank_63.d2bc966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_63.png
// module id = tiFB
// module chunks = 1